function cov_2671cx13vl() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/GoogleAuth.tsx";
  var hash = "bbf476c37c72c8865c6c7e001edbc50010bd2bb7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/GoogleAuth.tsx",
    statementMap: {
      "0": {
        start: {
          line: 22,
          column: 92
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "1": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 55,
          column: 4
        }
      },
      "2": {
        start: {
          line: 58,
          column: 92
        },
        end: {
          line: 87,
          column: 1
        }
      },
      "3": {
        start: {
          line: 62,
          column: 2
        },
        end: {
          line: 86,
          column: 4
        }
      },
      "4": {
        start: {
          line: 89,
          column: 94
        },
        end: {
          line: 98,
          column: 1
        }
      },
      "5": {
        start: {
          line: 92,
          column: 19
        },
        end: {
          line: 92,
          column: 29
        }
      },
      "6": {
        start: {
          line: 93,
          column: 2
        },
        end: {
          line: 95,
          column: 3
        }
      },
      "7": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 37
        }
      },
      "8": {
        start: {
          line: 97,
          column: 2
        },
        end: {
          line: 97,
          column: 35
        }
      },
      "9": {
        start: {
          line: 100,
          column: 44
        },
        end: {
          line: 180,
          column: 1
        }
      },
      "10": {
        start: {
          line: 106,
          column: 44
        },
        end: {
          line: 106,
          column: 92
        }
      },
      "11": {
        start: {
          line: 107,
          column: 42
        },
        end: {
          line: 107,
          column: 60
        }
      },
      "12": {
        start: {
          line: 108,
          column: 37
        },
        end: {
          line: 108,
          column: 55
        }
      },
      "13": {
        start: {
          line: 111,
          column: 30
        },
        end: {
          line: 121,
          column: 3
        }
      },
      "14": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 120,
          column: 6
        }
      },
      "15": {
        start: {
          line: 123,
          column: 32
        },
        end: {
          line: 133,
          column: 3
        }
      },
      "16": {
        start: {
          line: 124,
          column: 25
        },
        end: {
          line: 124,
          column: 94
        }
      },
      "17": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 34
        }
      },
      "18": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 127,
          column: 31
        }
      },
      "19": {
        start: {
          line: 129,
          column: 4
        },
        end: {
          line: 132,
          column: 7
        }
      },
      "20": {
        start: {
          line: 135,
          column: 32
        },
        end: {
          line: 150,
          column: 3
        }
      },
      "21": {
        start: {
          line: 136,
          column: 4
        },
        end: {
          line: 136,
          column: 24
        }
      },
      "22": {
        start: {
          line: 137,
          column: 4
        },
        end: {
          line: 137,
          column: 27
        }
      },
      "23": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 147,
          column: 6
        }
      },
      "24": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 149,
          column: 30
        }
      },
      "25": {
        start: {
          line: 152,
          column: 2
        },
        end: {
          line: 179,
          column: 4
        }
      },
      "26": {
        start: {
          line: 161,
          column: 12
        },
        end: {
          line: 173,
          column: 13
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 22,
            column: 92
          },
          end: {
            line: 22,
            column: 93
          }
        },
        loc: {
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 25
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 58,
            column: 92
          },
          end: {
            line: 58,
            column: 93
          }
        },
        loc: {
          start: {
            line: 61,
            column: 6
          },
          end: {
            line: 87,
            column: 1
          }
        },
        line: 61
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 89,
            column: 94
          },
          end: {
            line: 89,
            column: 95
          }
        },
        loc: {
          start: {
            line: 91,
            column: 5
          },
          end: {
            line: 98,
            column: 1
          }
        },
        line: 91
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 100,
            column: 44
          },
          end: {
            line: 100,
            column: 45
          }
        },
        loc: {
          start: {
            line: 105,
            column: 6
          },
          end: {
            line: 180,
            column: 1
          }
        },
        line: 105
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 111,
            column: 30
          },
          end: {
            line: 111,
            column: 31
          }
        },
        loc: {
          start: {
            line: 111,
            column: 44
          },
          end: {
            line: 121,
            column: 3
          }
        },
        line: 111
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 123,
            column: 32
          },
          end: {
            line: 123,
            column: 33
          }
        },
        loc: {
          start: {
            line: 123,
            column: 46
          },
          end: {
            line: 133,
            column: 3
          }
        },
        line: 123
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 135,
            column: 32
          },
          end: {
            line: 135,
            column: 33
          }
        },
        loc: {
          start: {
            line: 135,
            column: 46
          },
          end: {
            line: 150,
            column: 3
          }
        },
        line: 135
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 160,
            column: 18
          },
          end: {
            line: 160,
            column: 19
          }
        },
        loc: {
          start: {
            line: 161,
            column: 12
          },
          end: {
            line: 173,
            column: 13
          }
        },
        line: 161
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 95,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 95,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 93
      },
      "1": {
        loc: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 101,
            column: 37
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 101,
            column: 15
          },
          end: {
            line: 101,
            column: 37
          }
        }],
        line: 101
      },
      "2": {
        loc: {
          start: {
            line: 161,
            column: 12
          },
          end: {
            line: 173,
            column: 13
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 162,
            column: 14
          },
          end: {
            line: 170,
            column: 16
          }
        }, {
          start: {
            line: 172,
            column: 14
          },
          end: {
            line: 172,
            column: 85
          }
        }],
        line: 161
      },
      "3": {
        loc: {
          start: {
            line: 177,
            column: 7
          },
          end: {
            line: 177,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 177,
            column: 7
          },
          end: {
            line: 177,
            column: 20
          }
        }, {
          start: {
            line: 177,
            column: 24
          },
          end: {
            line: 177,
            column: 83
          }
        }],
        line: 177
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "bbf476c37c72c8865c6c7e001edbc50010bd2bb7"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2671cx13vl = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2671cx13vl();
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import "core-js/modules/es.function.name.js";
import React from 'react';
import { GoogleLogin } from 'react-google-login';
import { Button as NovoButton } from '@opendoor/bricks-next';
import { ErrorPrompt } from '@opendoor/bricks/complex';
import { Box, Button, Flex, Image, Text } from '@opendoor/bricks/core';
import { useTheme } from '@opendoor/bricks/system/theme';
import { useObservability } from '@opendoor/observability';
cov_2671cx13vl().s[0]++;
var ButtonEero = function ButtonEero(_ref) {
  var onClick = _ref.onClick,
    children = _ref.children;
  cov_2671cx13vl().f[0]++;
  cov_2671cx13vl().s[1]++;
  return /*#__PURE__*/React.createElement(Button, {
    "aria-label": "Sign in with Google",
    analyticsName: "google-auth",
    onClick: onClick,
    backgroundColor: "neutrals0",
    border: "2px solid var(--colors-neutrals100)",
    color: "neutrals100",
    width: "100%",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    _hover: {
      backgroundColor: 'neutrals30'
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Image, {
    height: "16px",
    pr: 3,
    src: "https://imgdrop.imgix.net/15c9f888b5c14a489e537a039f2f8883.png",
    alt: "Google logo"
  }), /*#__PURE__*/React.createElement(Text, {
    as: "span",
    fontSize: "s1",
    color: "neutrals100",
    fontWeight: "bold",
    lineHeight: "100"
  }, children)));
};
cov_2671cx13vl().s[2]++;
var ButtonNovo = function ButtonNovo(_ref2) {
  var onClick = _ref2.onClick,
    children = _ref2.children;
  cov_2671cx13vl().f[1]++;
  cov_2671cx13vl().s[3]++;
  return /*#__PURE__*/React.createElement(Button, {
    "aria-label": "Sign in with Google",
    variant: "secondary",
    analyticsName: "google-auth",
    onClick: onClick,
    size: "lg",
    minHeight: ['65px', null, '74px', '82px'],
    fontSize: "22px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Image, {
    height: "16px",
    pr: 3,
    src: "https://imgdrop.imgix.net/15c9f888b5c14a489e537a039f2f8883.png",
    alt: "Google logo"
  }), children));
};
cov_2671cx13vl().s[4]++;
var ThemedButton = function ThemedButton(props) {
  cov_2671cx13vl().f[2]++;
  var _ref3 = (cov_2671cx13vl().s[5]++, useTheme()),
    name = _ref3.name;
  cov_2671cx13vl().s[6]++;
  if (name == 'novo') {
    cov_2671cx13vl().b[0][0]++;
    cov_2671cx13vl().s[7]++;
    return /*#__PURE__*/React.createElement(ButtonNovo, props);
  } else {
    cov_2671cx13vl().b[0][1]++;
  }
  cov_2671cx13vl().s[8]++;
  return /*#__PURE__*/React.createElement(ButtonEero, props);
};
cov_2671cx13vl().s[9]++;
export var GoogleAuth = function GoogleAuth(_ref4) {
  var _ref4$buttonText = _ref4.buttonText,
    buttonText = _ref4$buttonText === void 0 ? (cov_2671cx13vl().b[1][0]++, 'Continue with Google') : _ref4$buttonText,
    clientId = _ref4.clientId,
    onAuthed = _ref4.onAuthed,
    showNovoStyle = _ref4.showNovoStyle;
  cov_2671cx13vl().f[3]++;
  var _ref5 = (cov_2671cx13vl().s[10]++, React.useState(null)),
    _ref6 = _slicedToArray(_ref5, 2),
    errorResponse = _ref6[0],
    setErrorResponse = _ref6[1];
  var _ref7 = (cov_2671cx13vl().s[11]++, React.useState('')),
    _ref8 = _slicedToArray(_ref7, 2),
    errorMessage = _ref8[0],
    setErrorMessage = _ref8[1];
  var _ref9 = (cov_2671cx13vl().s[12]++, useObservability()),
    trackError = _ref9.trackError,
    trackEvent = _ref9.trackEvent;

  // Called, e.g., when user is in incognito mode or has otherwise blocked third-party cookies
  cov_2671cx13vl().s[13]++;
  var onScriptLoadFailure = function onScriptLoadFailure(response) {
    cov_2671cx13vl().f[4]++;
    cov_2671cx13vl().s[14]++;
    trackError('google-auth', new Error('script load failure'), {
      details: response.details,
      error_code: response.error
    }, {
      skipSentry: true
    });
  };
  cov_2671cx13vl().s[15]++;
  var googleResponseFailure = function googleResponseFailure(response) {
    cov_2671cx13vl().f[5]++;
    var errorMessage = (cov_2671cx13vl().s[16]++, 'Sorry, the attempt to sign in with Google failed. Please try again.');
    cov_2671cx13vl().s[17]++;
    setErrorMessage(errorMessage);
    cov_2671cx13vl().s[18]++;
    setErrorResponse(response);
    cov_2671cx13vl().s[19]++;
    trackError('google-auth', new Error(errorMessage), {
      details: response.details,
      error_code: response.error
    });
  };
  cov_2671cx13vl().s[20]++;
  var googleResponseSuccess = function googleResponseSuccess(response) {
    cov_2671cx13vl().f[6]++;
    cov_2671cx13vl().s[21]++;
    setErrorMessage('');
    cov_2671cx13vl().s[22]++;
    setErrorResponse(null);
    cov_2671cx13vl().s[23]++;
    trackEvent('google-auth', 'authed', {
      email: response.profileObj.email,
      name: response.profileObj.name
    }, {
      categoryOverride: 'login'
    });
    cov_2671cx13vl().s[24]++;
    return onAuthed(response);
  };
  cov_2671cx13vl().s[25]++;
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(GoogleLogin, {
    clientId: clientId,
    onSuccess: googleResponseSuccess,
    onFailure: googleResponseFailure,
    onScriptLoadFailure: onScriptLoadFailure,
    render: function render(renderProps) {
      cov_2671cx13vl().f[7]++;
      cov_2671cx13vl().s[26]++;
      return showNovoStyle ? (cov_2671cx13vl().b[2][0]++, /*#__PURE__*/React.createElement(NovoButton, {
        analyticsName: "google-auth",
        label: buttonText,
        width: '100%',
        size: "medium",
        variant: "secondary",
        onPress: renderProps.onClick,
        disabled: renderProps.disabled
      })) : (cov_2671cx13vl().b[2][1]++, /*#__PURE__*/React.createElement(ThemedButton, {
        onClick: renderProps.onClick
      }, buttonText));
    }
  })), (cov_2671cx13vl().b[3][0]++, errorResponse) && (cov_2671cx13vl().b[3][1]++, /*#__PURE__*/React.createElement(ErrorPrompt, {
    paddingBottom: "16px",
    message: errorMessage
  })));
};
//# sourceMappingURL=GoogleAuth.mjs.map